<template lang="pug">
div
  //- img.mb-2.pointer.d-desktop(src="/new/img/Epicwin-Desktop.gif" @click="toSearch")
  //- img.mb-2.pointer.d-mobile(src="/new/img/Epicwin-Mobile.gif" @click="toSearch")
</template>
<script>
export default{
  methods:{
    toSearch(){
      window.open("https://www.google.com/search?q=epicwincasino.ph&oq=epicwincasino.ph&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIMCAEQIxgnGIAEGIoFMgcIAhAAGIAEMgcIAxAAGIAEMgcIBBAAGIAEMgcIBRAAGIAEMgcIBhAAGIAEMgcIBxAAGIAEMgcICBAAGIAE0gEJMjg2OWowajE1qAIIsAIB8QVYIZZvGgegig&sourceid=chrome&ie=UTF-8", "_blank")
    },
  }
}
</script>